export default __webpack_public_path__ + "static/media/CogTest-BrainSuite-Link-Buitton.8348f299.svg";